import p1 from "./1.jpg";
import p2 from "./2.jpg";
import p3 from "./3.jpg";
import p4 from "./4.jpg";

export const SLIDES = [p1, p2, p3, p4];
